import { useQuery } from "@tanstack/react-query";
import api from "../../../services/api";
import { IAlerts, IAlertsResponse } from "../@types";
import { alertQueryKeys } from "../queryKeys";

const useLatestUnresolvedAlerts = (
  fetchCount = 5
): {
  alerts: IAlerts;
  count: number;
  shouldConfigureAlerts: boolean;
} => {
  const { data: alerts } = useQuery({
    queryKey: alertQueryKeys.latestAlerts(fetchCount),
    queryFn: () =>
      api.listAlerts({
        page: 0,
        page_size: fetchCount,
        resolved_status: "unresolved",
        user: window.tcbase.userID
      }),
    refetchInterval: 30 * 1000,
    refetchOnMount: false,
    refetchOnWindowFocus: true
  });

  const { results = [], count }: IAlertsResponse = alerts?.data || {};

  const { data: subscriptionsCount } = useQuery({
    queryKey: alertQueryKeys.subscriptionsCount(),
    queryFn: () =>
      api.listSubscriptions({
        page: 1,
        page_size: 20
      }),
    select: ({ data }) => data.count,
    enabled: count === 0,
    refetchInterval: 30 * 1000,
    refetchOnMount: false,
    refetchOnWindowFocus: true
  });

  const shouldConfigureAlerts = subscriptionsCount === 0;

  return { alerts: results, count, shouldConfigureAlerts };
};

export default useLatestUnresolvedAlerts;
